import {defaultLang} from './default';
export const esLang = defaultLang;